import { useEffect, useState } from "react";
import { useSearchParams, useNavigate} from "react-router-dom";
import { CardContentSignIn } from "@warden-ui/card-components";
import { parseAmplifyConfig, parseQueryString, cloneSearchParams, isEmailFormat, useAuth } from "@warden-ui/common";
import { CPLink, CPPageBody } from "@warden-ui/common-components";
import { WardenApi } from "@warden-ui/api";
import { useTranslation } from "react-i18next";

const defaultQueryString: {[key: string]: string} = {
  team_domain: "",
  config: "",
  context: "",
  clear: "true",
}

export default function SignIn() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [t] = useTranslation();
  const queryString = parseQueryString(searchParams, defaultQueryString);
  const amplifyConfig = parseAmplifyConfig(queryString);
  auth.configureAmplify(amplifyConfig);

  const [region, setRegion] = useState(amplifyConfig.region);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [teamDomain, setTeamDomain] = useState("");
  const [teamInfo, setTeamInfo] = useState<{
    name: string;
    domain: string;
  } | undefined>(undefined);

  useEffect(() => {
    console.info("Referrer", document.referrer);
    setTeamInfo({
      name: "Cupix",
      domain: "",
    });
  }, []);

  const configureFailed = () => {
    if (!auth.isConfigured) {
      console.error("Auth is not configured.");
      return true;
    }
    return false;
  };

  const onClickEmailSignin = async (email: string) => {
    if (configureFailed()) {
      return;
    }

    if (email.length === 0) {
      setErrorMessage(t('errors.email_empty'));
      return;
    }

    if (!isEmailFormat(email)) {
      setErrorMessage(t('errors.email_invalid'));
      return;
    }

    setLoading(true);
    WardenApi.getUserInfo(email, { region: region })
      .then((data) => {
        const params = cloneSearchParams(searchParams);
        params.set("email", email);

        if (data.status === "CONFIRMED") {
          navigate(`/signin/password?${params.toString()}`);

        } else {
          params.set("migration", "true");
          navigate(`/reset_password/request?${params.toString()}`);
        }
      })
      .catch((reason) => {
        setErrorMessage(t('signin.error.email_not_found'));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (auth.isSignedIn) {
    navigate(`/redirect?${searchParams.toString()}`);
  }
  
  return (
    <CPPageBody
      regions={amplifyConfig.regions}
      defaultRegion={amplifyConfig.region}
      showRegion={false}
    >
      <CardContentSignIn
        email={queryString.email}
        teamName={teamInfo?.name}
        teamDomain={teamDomain}
        enabledEmailSignin={true}
        onClickEmailSignin={onClickEmailSignin}

        // TODO: integrate with Frontend
        selfSignup={queryString.email_domain} 
        emailDomain="cupix.com"
        showSSOSignIn={queryString.sso}
        teamSelect={queryString.team_select}
        // end
 
        errorMessage={errorMessage}
        loading={loading}
        skeletonLoading={teamInfo === undefined}
      >
      
      {/*  TODO: integrate with Frontend */}
      {queryString.signup && <CPLink label="Sign up" /> }
    </CardContentSignIn>
    </CPPageBody>
  );
}
